import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import { get } from 'lodash-es';

const Header = ({ theme, app, strings, mode }) => {
  const currentTheme = get(theme, 'current', 'coog');
  const defaultPageTitle = get(strings, 'pageTitle');
  const defaultCanonical = get(strings, 'canonical');
  const defaultTitle = get(app, 'title');
  let defaultSubTitle = get(app, 'subTitle');

  if (mode === 'forget_password') {
    defaultSubTitle = get(app, 'subTitleForgetPassword');
  } else if (mode === 'change_password') {
    defaultSubTitle = get(app, 'subTitleChangePassword');
  } else if (mode === 'signature') {
    defaultSubTitle = get(app, 'subTitleSignature');
  }

  if (currentTheme !== 'coog') {
    const login = get(theme, 'login', {});
    const config = get(login, `list.${currentTheme}`);
    const pageTitle = get(config, 'pageTitle', defaultPageTitle);
    const canonical = get(config, 'canonical', defaultCanonical);
    const title = get(config, 'title', defaultTitle);
    const subTitle = get(config, 'subTitle', defaultSubTitle);

    return (
      <>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{pageTitle}</title>
          <meta name="description" content={pageTitle} />
          <link rel="canonical" href={canonical} />
        </Helmet>
        <hgroup className="coog-header">
          <h1>{title}</h1>
          <h3>{subTitle}</h3>
        </hgroup>
      </>
    );
  }
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{defaultPageTitle}</title>
        <meta name="description" content={defaultPageTitle} />
        <link rel="canonical" href={defaultCanonical} />
      </Helmet>
      <hgroup className="coog-header">
        <h1>{defaultTitle}</h1>
        <h3>{defaultSubTitle}</h3>
      </hgroup>
    </>
  );
};

Header.propTypes = {
  theme: PropTypes.object.isRequired, // eslint-disable-line
  app: PropTypes.object.isRequired, // eslint-disable-line
  strings: PropTypes.object.isRequired, // eslint-disable-line
  mode: PropTypes.string,
};

Header.defaultProps = {
  mode: undefined,
};

export default Header;
